export default class extends Controller {
  static targets = ['checkbox', 'label'];

  connect() {
    this.updateLabelClass();
  }

  updateCheckbox(event) {
    event.preventDefault();
    this.checked = !this.checked;
  }

  updateLabelClass() {
    this.labelTarget.classList[this.checked ? 'add' : 'remove']('active-checkbox');
  }

  //
  // GETTERS AND SETTERS
  //

  get checked() {
    return this.checkboxTarget.checked;
  }

  set checked(isChecked) {
    this.checkboxTarget.checked = isChecked;
    this.checkboxTarget.dispatchEvent(new Event('change'));
    this.updateLabelClass();
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/shared/toggle-checkbox-controller.js